/**
 *
 * @param text A string to extract initials from. Usually a name.
 * @returns A 0, 1 or 2 character string that represents initials from the input string.
 */
export const getInitials = (text) => {
    var _a, _b, _c;
    const trimmedText = text.trim();
    // Check the string actually has text in it
    if (!trimmedText)
        return trimmedText;
    const splitText = trimmedText.split(' ');
    // only 1 word was supplied
    if (splitText.length === 1) {
        return (_a = splitText[0]) === null || _a === void 0 ? void 0 : _a.substring(0, 2).toUpperCase();
    }
    // Otherwise more than one word was supplied
    const initial1 = ((_b = splitText[0]) === null || _b === void 0 ? void 0 : _b[0]) || '';
    const initial2 = ((_c = splitText[splitText.length - 1]) === null || _c === void 0 ? void 0 : _c[0]) || '';
    return `${initial1.toUpperCase()}${initial2.toUpperCase()}`;
};
//# sourceMappingURL=helpers.js.map